import { handleActions } from 'redux-actions';
import {
  REQUEST_BIRTHDAYS,
  REQUEST_BIRTHDAYS_SUCCESS,
  REQUEST_BIRTHDAYS_FAILURE,
} from 'constants/ActionTypes';

const initalState = {
  birthdays: [],
  loaded: false,
  error: null,
  hasError: false,
};

export default handleActions({
  [REQUEST_BIRTHDAYS]: state => ({
    ...state,
    loaded: false,
  }),
  [REQUEST_BIRTHDAYS_SUCCESS]: (state, { birthdays }) => ({
    ...state,
    birthdays,
    loaded: true,
  }),
  [REQUEST_BIRTHDAYS_FAILURE]: (state, { error }) => ({
    ...state,
    error,
    hasError: true,
  }),
}, initalState);



// WEBPACK FOOTER //
// ./src/reducers/BirthdaysReducer.js